const RATIO_DEGREES = 180 / Math.PI;

export const toDegrees = (radians: number): number => {
  return ((radians * RATIO_DEGREES + Number.EPSILON) * 100) / 100;
};
